"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _Box = _interopRequireDefault(require("../Box"));

var _index = require("../index");

var _useWindowSize = _interopRequireDefault(require("../useWindowSize"));

var __jsx = _react["default"].createElement;

function Display(_ref) {
  var when = _ref.when,
      children = _ref.children;

  var _useState = (0, _react.useState)(false),
      mounted = _useState[0],
      setMounted = _useState[1];

  var size = (0, _useWindowSize["default"])();
  (0, _react.useEffect)(function () {
    setMounted(true);
  }, []);
  var currentValue = (0, _index.responsiveValueCurrent)(when);
  var shouldBeDisplayed = !mounted || typeof window === "object" && currentValue;
  var sx = {};

  if (!mounted) {
    // on SSR and first render we use display: none to allow no blinking and good SEO
    sx = {
      display: when.map(function (t) {
        return t === null ? null : t === true ? "block" : "none";
      })
    };
  } // If mounted, then we can simply not render not displayed items to decrease rerenders overload performance


  if (!shouldBeDisplayed) {
    return null;
  }

  return __jsx(_Box["default"], {
    sx: sx
  }, children);
}

var _default = Display;
exports["default"] = _default;